import * as inplayActions from './lsports.inplay.actions';
import * as prematchActions from './lsports.prematch.actions';
export * from './lsports.inplay.actions';
export * from './lsports.prematch.actions';

export function mapLSportsDispatchToProps(dispatch) {
    return {
        lsportsActions: {
            inplay: inplayActions.mapLSportsInplayDispatchToProps(dispatch).inplay,
            prematch: prematchActions.mapLSportsPrematchDispatchToProps(dispatch).prematch,
        },
    };
}
